var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifyPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "41px",
    viewBox: "0 0 40 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pending\u5F69\u8272_40dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 328,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0419\\u66F4\\u65B0--\\u64CD\\u4F5C\\u63D0\\u793A\\u6C14\\u6CE1",
    transform: "translate(-1076.000000, -390.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11\\u5907\\u4EFD-5",
    transform: "translate(1058.000000, 370.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pending\\u5F69\\u8272_40dp",
    transform: "translate(18.000000, 20.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L40,0 L40,40 L0,40 L0,0 Z M0,0 L40,0 L40,40 L0,40 L0,0 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,3.33333333 L21.2028837,3.3761427 C29.8421053,3.99322113 36.6666667,11.204474 36.6666667,20 L36.6666667,20 L33.3333333,20 C33.3333333,12.6333333 27.3666667,6.66666667 20,6.66666667 L20,6.66666667 L20,3.33333333 L20,3.33333333 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#7269EF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyPending);
export default __webpack_public_path__ + "static/media/notify_pending.232fa05163f0fb28dac689b32c4ff46a.svg";
export { ForwardRef as ReactComponent };